import { render } from "./village_master.vue?vue&type=template&id=1a14435a&scoped=true"
import script from "./village_master.vue?vue&type=script&lang=js"
export * from "./village_master.vue?vue&type=script&lang=js"

import "./village_master.vue?vue&type=style&index=0&id=1a14435a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a14435a"]])

export default __exports__